"use strict";

import PageCommon from "../PageCommon";

export default class Filter extends PageCommon {
    constructor(props) {
        super();
        this.data = {
            Name: props.Name,
            Tags: [...props.Tags],
        };
        this.selected = 0;
    }

    set(object) {}

    get() {
        return this.data;
    }

    renderListItem(searchManager) {
        const _this = this;
        const modelId = "#model-filters-list";
        const filterRow = document.querySelector(`${modelId} .nav-item`).cloneNode(true);
        const submenuList = filterRow.querySelector(".submenu-list");
        const submenuRow = submenuList.querySelector(".form-check").cloneNode(true);
        submenuList.textContent = "";

        const rowName = this._normalizza_track_prop(`${this.data.Name}`);
        const rowLink = filterRow.querySelector("a.nav-link");
        rowLink.href = `#${rowName}`;
        rowLink.querySelector(".nav-link-label").innerHTML = this.data.Name;
        rowLink.querySelector(".badge").textContent = "";
        filterRow.querySelector(".fm-nav-submenu").id = rowName;
        if (this.data.Tags) {
            this.data.Tags.map((subFilterName) => {
                const subRow = submenuRow.cloneNode(true);
                const subRowName = this._normalizza_track_prop(`${this.data.Name} ${subFilterName}`);
                const input = subRow.querySelector("input");
                input.id = subRowName;
                input.dataset.name = subFilterName;
                input.addEventListener("click", (event) => {
                    searchManager.searchCategory(event.currentTarget.dataset.name);
                    if (event.currentTarget.checked) {
                        _this.selected++;
                    } else {
                        _this.selected--;
                        if (_this.selected < 0) _this.selected = 0;
                    }
                    rowLink.querySelector(".badge").textContent = _this.selected ? _this.selected : "";
                });
                const label = subRow.querySelector("label");
                label.setAttribute("for", subRowName);
                label.innerHTML = subFilterName;
                filterRow.querySelector(".submenu-list").appendChild(subRow);
            });
        }
        return filterRow;
    }

    renderHeaderListItem(elements, container) {
        const modelId = "#model-categories-header";
        const wrapper = document.querySelector(`${modelId} .col`).cloneNode(true);
        wrapper.querySelector(".category-name").innerHTML = this.data.Name;
        const list = wrapper.querySelector("ul.nav");
        if (this.data.Tags) {
            this.data.Tags.map((subFilterName, index) => {
                if (index < elements) {
                    const modelId = "#model-categories-header-item";
                    const item = document.querySelector(`${modelId} .category-item`).cloneNode(true);
                    item.querySelector("a").textContent = subFilterName;
                    // item.querySelector("a").href = this.setUrlParams("find-music.html", [{ key: "filters", value: subFilterName }]);
                    item.querySelector("a").href = this.setUrlParams("/find-music", [{ key: "filters", value: subFilterName }]);
                    list.appendChild(item);
                }
            });
        }
        container.appendChild(wrapper);
    }

    dispose() {
        this.data = {};
    }
}
